(function () {
  var d = document, w = window;
  var bar = d.getElementById('VeroSIL'), pop = d.getElementById('VeroSILPop');
  if (!bar || bar.__on) return; bar.__on = true;
  var start = Date.parse(bar.getAttribute('data-start')), end = Date.parse(bar.getAttribute('data-end'));
  var pct = parseFloat(bar.getAttribute('data-pct')) || 15, k = 1 - pct / 100;
  var logo = bar.getAttribute('data-logo');
  var preview = /[?&]sil=1\b/.test(location.search);
  var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function isLive() { var n = Date.now(); return preview || (n >= start && n < end); }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function parts(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }; }
  function boxes(p) { return '<div><b>' + p.d + '</b><i>ימים</i></div><div><b>' + two(p.h) + '</b><i>שעות</i></div><div><b>' + two(p.m) + '</b><i>דקות</i></div><div><b>' + two(p.s) + '</b><i>שניות</i></div>'; }
  function money(c) { c = Math.round(c); return '₪' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  var clock = bar.querySelector('[data-sil-clock]'), clock2 = pop && pop.querySelector('[data-sil-clock2]');
  function tick() {
    if (!isLive()) { bar.hidden = true; d.documentElement.classList.remove('vsil-live'); return false; }
    bar.hidden = false;
    var p = parts(end - Date.now()), html = boxes(p);
    if (clock) clock.innerHTML = html;
    if (clock2 && !pop.hidden) clock2.innerHTML = html;
    return true;
  }
  if (!tick()) return;
  d.documentElement.classList.add('vsil-live');
  setInterval(tick, 1000);

  function goBuy() {
    var t = d.querySelector('#MainContent variant-selects');
    if (t) { var r = t.getBoundingClientRect(); w.scrollTo({ top: r.top + w.scrollY - 110, behavior: 'smooth' }); }
    else location.href = root + '#MainContent';
  }
  bar.addEventListener('click', goBuy);

  /* ---------- on-page elements ---------- */
  var chip = '<span class="vsil-chip"><img src="' + logo + '" alt="ShoppingIL by Google" width="80" height="30"></span>';
  var product = null;
  function curVariant() {
    if (!product) return null;
    var inp = d.querySelector('#MainContent product-form input[name="id"]');
    var id = String(inp ? inp.value : '');
    return product.variants.filter(function (v) { return String(v.id) === id; })[0] || product.variants[0];
  }
  function priceBox() {
    var pr = d.querySelector('#MainContent [id^="price-"]');
    if (!pr) return;
    var box = d.getElementById('VeroSILPrice');
    if (!box) {
      box = d.createElement('div'); box.id = 'VeroSILPrice'; box.className = 'vsil-pb';
      pr.parentNode.insertBefore(box, pr.nextSibling);
    }
    var o = getComputedStyle(pr).order; if (box.style.order !== o) box.style.order = o;
    var v = curVariant(); if (!v) return;
    var ref = v.compare_at_price > v.price ? v.compare_at_price : v.price, now = Math.round(v.price * k), save = ref - now;
    var html = chip + '<div class="vsil-pb__t"><span class="vsil-pb__k">מחיר ShoppingIL · ' + pct + '% הנחה על כל האתר</span>' +
      '<span class="vsil-pb__p"><b>' + money(now) + '</b><s>' + money(ref) + '</s><em>−' + Math.round(save / ref * 100) + '%</em></span>' +
      '<span class="vsil-pb__n">סה״כ חוסכים ' + money(save) + ' · יורד אוטומטית בעגלה</span></div>';
    if (box.__h !== html) { box.innerHTML = html; box.__h = html; }
  }
  function gallery() {
    var g = d.querySelector('#MainContent .product__media-wrapper');
    if (!g || g.querySelector('.vsil-gb')) return;
    var b = d.createElement('div'); b.className = 'vsil-gb'; b.innerHTML = chip + '<span class="vsil-gb__p">−' + pct + '%</span>';
    g.style.position = 'relative'; g.appendChild(b);
  }
  var flag = '<svg viewBox="0 0 22 16" aria-hidden="true"><rect x=".5" y=".5" width="21" height="15" rx="2" fill="#fff" stroke="#c9d3e3"/><rect y="2.2" width="22" height="2.1" fill="#0038b8"/><rect y="11.7" width="22" height="2.1" fill="#0038b8"/><path d="M11 5l2.5 4.3h-5zM11 11l-2.5-4.3h5z" fill="none" stroke="#0038b8" stroke-width=".85" stroke-linejoin="round"/></svg>';
  var poi = '<span class="vsil-poi">' + flag + '<span>PRODUCT OF ISRAEL</span></span>';
  function hero() {
    var h = d.querySelector('section.vhv');
    if (!h || d.querySelector('.vsil-hs')) return;
    var a = d.createElement('div'); a.className = 'vsil-hs'; a.setAttribute('role', 'button'); a.tabIndex = 0;
    a.innerHTML = '<span class="vsil-hs__msg"><span class="vsil-hs__k">ShoppingIL 2026 · הכי שווה לקנות מכאן</span>' +
      '<span class="vsil-hs__h"><em>' + pct + '%</em> הנחה על כל האתר</span></span>' + poi +
      '<span class="vsil-hs__cta">לבחירת החבילה ←</span><span class="vsil-hs__div" aria-hidden="true"></span>' + chip;
    a.addEventListener('click', goBuy);
    var wr = d.createElement('div'); wr.className = 'vsil-hsw'; wr.appendChild(a);
    var bg = getComputedStyle(h).backgroundColor;
    wr.style.background = (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') ? '#1E2416' : bg;
    h.parentNode.insertBefore(wr, h.nextSibling);
  }
  function galleryPoi() {
    var g = d.querySelector('#MainContent .vsil-gb');
    if (!g || g.querySelector('.vsil-poi')) return;
    g.insertAdjacentHTML('beforeend', poi);
  }
  function sticky() {
    var p = d.querySelector('.vst__p'); if (!p) return;
    var b = p.querySelector('b'); if (!b || b.hasAttribute('data-sil')) return;
    var c = Math.round(parseFloat(b.textContent.replace(/[^\d.]/g, '')) * 100); if (!c) return;
    b.setAttribute('data-sil', '1'); b.textContent = money(c * k);
    if (!p.querySelector('s')) { var ns = d.createElement('s'); ns.textContent = money(c); b.parentNode.insertBefore(ns, b.nextSibling); }
  }
  function apply() { try { priceBox(); gallery(); galleryPoi(); hero(); sticky(); } catch (e) {} }
  var pend = 0;
  function later() { if (pend) return; pend = setTimeout(function () { pend = 0; apply(); }, 60); }
  var form = d.querySelector('#MainContent product-form');
  if (form) {
    var h = (form.closest('[data-product-handle]') || {}).getAttribute ? form.closest('[data-product-handle]').getAttribute('data-product-handle') : null;
    fetch(root + 'products/' + (h || 'vero-high-polyphenol-olive-oil-330ml') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants) { product = p; apply(); } }).catch(function () {});
    d.addEventListener('change', function () { [50, 400, 1000].forEach(function (ms) { setTimeout(apply, ms); }); });
  }
  apply();
  new MutationObserver(later).observe(d.body, { childList: true, subtree: true });

  /* ---------- popup: once per visit ---------- */
  if (!pop) return;
  var seen = false;
  try { seen = sessionStorage.getItem('vero_sil_seen') === '1'; } catch (e) {}
  if ((seen && !preview) || (w.Shopify && Shopify.designMode)) return;
  function close() {
    pop.classList.remove('is-on');
    setTimeout(function () { pop.hidden = true; }, 350);
    d.removeEventListener('keydown', onKey);
    try { sessionStorage.setItem('vero_sil_seen', '1'); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function open() {
    if (d.querySelector('cart-drawer.active')) return;
    pop.hidden = false; tick();
    requestAnimationFrame(function () { pop.classList.add('is-on'); var c = pop.querySelector('.vsil-pop__cta'); if (c) c.focus({ preventScroll: true }); });
    d.addEventListener('keydown', onKey);
  }
  pop.addEventListener('click', function (e) {
    if (e.target === pop || (e.target.closest && e.target.closest('[data-sil-close]'))) { close(); return; }
    if (e.target.closest && e.target.closest('[data-sil-go]')) { close(); goBuy(); }
  });
  setTimeout(open, 1800);
})();
